<template>
  <div>
    <div
      v-if="selectedType == ''"
      class="flex flex-wrap relative z-0 justify-center gap-1"
      :class="{
        'flex': showFilters,
        'hidden xl:flex': !showFilters,
      }"
    >
      <button
        @click="setType('')"
        :class="{
          'button-primary': activeType == '',
          'button-white': activeType != '',
        }"
      >
        All
      </button>

      <button
        v-for="type in types"
        :key="type.term_id"
        @click="setType(type.name)"
        :class="{
          'button-primary': activeType == type.name,
          'button-white': activeType != type.name,
        }"
        v-html="type.name"
      >
      </button>

    </div>

    <transition-group name="project-grid" tag="div" appear class="w-full flex flex-wrap gap-4 md:gap-8 lg:gap-14 justify-center py-4 md:pt-8 lg:pt-12" >

      <a
        v-for="project in projects"
        :key="project.ID"
        :href="project.link"
        :title="project.title"
        :aria-label="'learn more about ' + project.title"
        class="relative flex flex-col group hover:cursor-pointer bg-white w-full md:max-w-xs lg:max-w-sm shadow-xl shadow-primary-light/10" >
        <div
          v-if="project.photo"
          class="aspect-image bg-center bg-cover bg-no-repeat bg-gray-200"
          v-lazy:background-image="project.photo['sizes'] ? project.photo['sizes']['medium'] : project.photo['url']"
        ></div>
        <div class="flex flex-col p-4 md:p-8 flex-grow gap-2 text-center">
          <h3 class="page-h3 leading-none uppercase text-primary font-bold tracking-wider" v-html="project.title" ></h3>
          <span v-if="project.taxonomy_location" >{{ project.taxonomy_location.name }}</span>
        </div>
        <span class="opacity-0 h-0 group-hover:h-auto overflow-hidden group-hover:opacity-100 flex bg-transparent transform-all duration-500 group-hover:absolute top-0 right-0 bottom-0 left-0 group-hover:bg-gradient-to-tr from-primary-dark to-primary-dark/70 group-hover:backdrop-multiply justify-center items-center" >
          <span class="button-outline-white uppercase tracking-widest" tabindex="-1" >project info</span>
        </span>
      </a>

    </transition-group>

    <div v-if="this.limit > 0" class="w-auto mt-2 lg:mt-10 text-center">
      <a href="/projects/" title="View all projects" class="btn-primary">
        View all Projects
      </a>
    </div>
  </div>
</template>
<script>
export default {
  name: "ProjectGallery",

  props: {
    locations: {
      type: Object,
      default: () =>{}
    },
    types: {
      type: Object,
      default: () =>{}
    },
    selectedLocation: {
      type: String,
      default: ""
    },
    selectedType: {
      type: String,
      default: ""
    },
    limit: {
      type: Number,
      default: 0
    },
  },

  data () {
    return {
      activeLocation: this.selectedLocation,
      activeType: this.selectedType,
      showFilters: true,
      loading: true,
      projects: [],
      projectData: []
    }
  },

  mounted () {
    this.getProjects()
  },

  methods: {
    setType (value) {
      this.activeType = value;
      this.projects = this.filter()
    },
    setLocation (value) {
      this.activeLocation = value;
      // this.filter()
    },

    async getProjects () {
      this.projectData = await fetch('/wp-json/kma/v1/projects').then(r => r.json())
      this.projects = this.filter()

      if(this.limit > 0) {
        this.projects = this.projects.slice(0, this.limit)
      }
    },

    filter () {
      return this.activeType !== '' ? this.projectData.filter( project => project.taxonomy_type.name == this.activeType ) : this.projectData
    }
  }
}
</script>
<style>
.project-grid-enter-active, .project-grid-leave-active {
  transition: all .4s;
}

.project-grid-enter-from {
  opacity: 0;
  transform: scale(90%);
  /* transform: translateY(-30px); */
}
.project-grid-enter-to {
  opacity: 1;
  transform: scale(100%);
  /* transform: translateY(0); */
}

.project-grid-leave-from {
  opacity: 1;
  transform: scale(100%);
  /* transform: translateY(0); */
}
.project-grid-leave-to {
  opacity: 0;
  /* transform: translateY(30px); */
  transform: scale(90%);
}

.project-grid-move {
  transition: all .3s ease;
}
</style>
